<script>
  import { getStyleValue, generateSocialIcon } from "../../Common/tools";
  import ImageHeader from "./ImageHeader.svelte";
  import TextEditor from "../../Common/TextEditor.svelte";
  import Unsubscribe from "./Unsubscribe.svelte";
  import {External} from "../../external";

  export let data, meta, globalStyle, onChange;

  function change(prop, val) {
    onChange();
    data = Object.assign({}, data, { [prop]: val });
  }
</script>

{#if !data.hideLogo}
  <tr style="vertical-align: top;" valign="top">
    <ImageHeader data={data} globalStyle={globalStyle} isChild={true} style="text-align: center;" />
  </tr>
  <tr>
    <td class="spacer" style="font-size: 20px; line-height: 20px; height: 20px;" height="20">&nbsp;</td>
  </tr>
{/if}
<tr style="vertical-align: top;" valign="top">
  <th class="column" style="padding-left: 40px; padding-right: 40px;" width={getStyleValue(globalStyle.width, 600)}>
    <center>
      <table class="menu mobile-center" style="text-align: center;" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            {#each data.menu as item, i (item)}
              {#if item.link}
                <th class="menu-item serif" style="padding: 0 10px;">
                  <a href="" style="background-color: rgba(150,150,150,.1); width:30px; height: 30px; line-height: 30px; display: inline-block;border-radius: 50%;">
                    <img src={generateSocialIcon(data, i)} alt="" style="vertical-align: middle;width:15px;height:15px; padding: 8px;" />
                  </a>
                </th>
              {/if}
            {/each}
          </tr>
        </tbody>
      </table>
    </center>
  </th>
</tr>
{#if External.Website.emailMarketingSettings.companyName || External.Website.emailMarketingSettings.companyAddress}
  <tr>
    <td class="spacer" height="30" style="line-height: 30px;">
      <div class="spacer-bottom ui-resizable" style="bottom: 0px; position: absolute; width: 100%; height: 30px;">
        &nbsp;
        <div class="ui-resizable-handle ui-resizable-s" style="z-index: 90; bottom: 0px; top: 0px; height: unset; position: absolute;" />
      </div>
    </td>
  </tr>
  <tr>
    <th class="column column-st" width={getStyleValue(globalStyle.width, 600)} style="color: {data.style.brandColor};text-align: {data.style.position};">
      {#if External.Website.emailMarketingSettings.companyName}{External.Website.emailMarketingSettings.companyName}{/if}
      {#if External.Website.emailMarketingSettings.companyName && External.Website.emailMarketingSettings.companyAddress}<br />{/if}
      {#if External.Website.emailMarketingSettings.companyAddress}{External.Website.emailMarketingSettings.companyAddress}{/if}
    </th>
  </tr>
  <tr>
    <td class="spacer" height="30" style="line-height: 30px;">
      <div class="spacer-bottom ui-resizable" style="bottom: 0px; position: absolute; width: 100%; height: 30px;">
        &nbsp;
        <div class="ui-resizable-handle ui-resizable-s" style="z-index: 90; bottom: 0px; top: 0px; height: unset; position: absolute;" />
      </div>
    </td>
  </tr>
{/if}
<!--
<tr>
    <th class="column" style="padding-left: 40px; padding-right: 40px; color: #1F2225;"
        width="{getStyleValue(globalStyle.width, 600)}">
        <div class="spacer" style="font-size: 50px; line-height: 50px;">&nbsp;</div>
        <TextEditor bind:data={data.content} meta={meta} onChange={val => change('content', val)} emailEditor={true} />
        <div class="spacer" style="font-size: 50px; line-height: 50px;">&nbsp;</div>
    </th>
</tr>-->
<tr>
  <th class="column" style="color: #969AA1; text-align: center; padding-left: 40px; padding-right: 40px;" width="640">
    <table class="row" cellspacing="0" cellpadding="0">
      <tbody>
        <tr>
          <th class="column" style="color: #969AA1; font-weight: 400; text-align: center;" width={getStyleValue(globalStyle.width, 600)}>
            <TextEditor bind:data={data.footer} meta={meta} onChange={(val) => change("footer", val)} emailEditor={true} />
            <Unsubscribe data={data} globalStyle={globalStyle} isChild={true} />
          </th>
        </tr>
        <tr>
          <td class="spacer" style="font-size: 30px; line-height: 30px;" height="30">&nbsp;</td>
        </tr>
      </tbody>
    </table>
  </th>
</tr>
